var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"levelBar"},[_vm._v(" Level: "),_c('div',{staticClass:"levels"},_vm._l((_vm.levelMax),function(index){return _c('div',{key:index},[_c('div',{staticClass:"level",class:{filled: index <= _vm.level}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }